export const cases = [
  {
    id: 'pixel',
    nameKey: 'cases.c1.name',
    categoryKey: 'cases.c1.category',
    tvlKey: 'cases.c1.tvl',
    featured: true,
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20geometric%20NFT%20digital%20art%20platform%20launch%20visual%20with%20floating%20crystalline%20pixel%20blocks%20and%20warm%20golden%20light%20on%20cream%20off-white%20background%2C%20minimal%20editorial%20isometric%20composition%2C%20soft%20amber%20and%20stone%20gray%20abstract%20forms%2C%20premium%20art-tech%20magazine%20illustration%20style%20with%20clean%20negative%20space%2C%20subtle%20lime%20accent%20highlight%2C%20futuristic%20yet%20elegant%20digital%20art%20gallery%20mood&width=800&height=800&seq=case-pixel-origin&orientation=squarish',
  },
  {
    id: 'vault',
    nameKey: 'cases.c2.name',
    categoryKey: 'cases.c2.category',
    tvlKey: 'cases.c2.tvl',
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20isometric%20NFT%20membership%20pass%20with%20layered%20geometric%20shapes%20and%20holographic%20metallic%20surfaces%20on%20warm%20cream%20paper%20background%2C%20minimal%20editorial%20illustration%2C%20muted%20amber%20and%20stone%20palette%20with%20subtle%20iridescent%20highlights%2C%20premium%20lifestyle%20magazine%20aesthetic%20with%20generous%20negative%20space%2C%20exclusive%20VIP%20token%20pass%20abstract%20visual&width=800&height=800&seq=case-vault-society&orientation=squarish',
  },
  {
    id: 'forge',
    nameKey: 'cases.c3.name',
    categoryKey: 'cases.c3.category',
    tvlKey: 'cases.c3.tvl',
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20gaming%20NFT%20assets%20with%20floating%20crystalline%20weapon%20and%20armor%20collectibles%20on%20warm%20off-white%20background%2C%20editorial%20minimalism%2C%20clean%20geometric%20isometric%20art%20with%20soft%20stone%20gray%20tones%20and%20warm%20golden%20accent%2C%20premium%20game%20art%20publication%20style%2C%20dynamic%20floating%20NFT%20card%20composition%20with%20subtle%20particle%20effects&width=800&height=800&seq=case-meta-forge&orientation=squarish',
  },
  {
    id: 'eden',
    nameKey: 'cases.c4.name',
    categoryKey: 'cases.c4.category',
    tvlKey: 'cases.c4.tvl',
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20NFT%20marketplace%20launch%20platform%20isometric%20building%20blocks%20with%20subtle%20blockchain%20lattice%20and%20digital%20collectible%20cards%20floating%20on%20cream%20background%2C%20editorial%20architectural%20illustration%2C%20warm%20amber%20highlights%20and%20stone%20neutrals%2C%20premium%20art%20marketplace%20magazine%20aesthetic%20with%20clean%20composition%2C%20elegant%20curated%20digital%20gallery%20visual&width=800&height=800&seq=case-eden-drop&orientation=squarish',
  },
];